const APP_VERSION = "1.5.24";